module.exports = __webpack_public_path__ + "img/82.d6560606.jpg";